(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["editorial-curiosity"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function revealAll(elements) {
      elements.forEach(function (el) {
        el.classList.add('is-revealed');
      });
    }

    function observe(elements) {
      if (!elements.length) return;

      if (prefersReducedMotion || !('IntersectionObserver' in window)) {
        revealAll(elements);
        return;
      }

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-revealed');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -10% 0px' });

      elements.forEach(function (el) {
        observer.observe(el);
      });
    }

    function init(scope) {
      observe(Array.prototype.slice.call(scope.querySelectorAll('[data-scroll-reveal]:not(.is-revealed)')));
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init(document);
      });
    } else {
      init(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["editorial-doubt"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function revealAll(elements) {
      elements.forEach(function (el) {
        el.classList.add('is-revealed');
      });
    }

    function observe(elements) {
      if (!elements.length) return;

      if (prefersReducedMotion || !('IntersectionObserver' in window)) {
        revealAll(elements);
        return;
      }

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-revealed');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -10% 0px' });

      elements.forEach(function (el) {
        observer.observe(el);
      });
    }

    function init(scope) {
      observe(Array.prototype.slice.call(scope.querySelectorAll('[data-scroll-reveal]:not(.is-revealed)')));
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init(document);
      });
    } else {
      init(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["editorial-finalcta"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function revealAll(elements) {
      elements.forEach(function (el) {
        el.classList.add('is-revealed');
      });
    }

    function observe(elements) {
      if (!elements.length) return;

      if (prefersReducedMotion || !('IntersectionObserver' in window)) {
        revealAll(elements);
        return;
      }

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-revealed');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -10% 0px' });

      elements.forEach(function (el) {
        observer.observe(el);
      });
    }

    function init(scope) {
      observe(Array.prototype.slice.call(scope.querySelectorAll('[data-scroll-reveal]:not(.is-revealed)')));
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init(document);
      });
    } else {
      init(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["editorial-mechanism"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function revealAll(elements) {
      elements.forEach(function (el) {
        el.classList.add('is-revealed');
      });
    }

    function observe(elements) {
      if (!elements.length) return;

      if (prefersReducedMotion || !('IntersectionObserver' in window)) {
        revealAll(elements);
        return;
      }

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-revealed');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -10% 0px' });

      elements.forEach(function (el) {
        observer.observe(el);
      });
    }

    function init(scope) {
      observe(Array.prototype.slice.call(scope.querySelectorAll('[data-scroll-reveal]:not(.is-revealed)')));
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init(document);
      });
    } else {
      init(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["editorial-newbelief"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function revealAll(elements) {
      elements.forEach(function (el) {
        el.classList.add('is-revealed');
      });
    }

    function observe(elements) {
      if (!elements.length) return;

      if (prefersReducedMotion || !('IntersectionObserver' in window)) {
        revealAll(elements);
        return;
      }

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-revealed');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -10% 0px' });

      elements.forEach(function (el) {
        observer.observe(el);
      });
    }

    function init(scope) {
      observe(Array.prototype.slice.call(scope.querySelectorAll('[data-scroll-reveal]:not(.is-revealed)')));
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init(document);
      });
    } else {
      init(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["editorial-objections"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.editorialObjectionsBound === 'true') return;
      root.dataset.editorialObjectionsBound = 'true';

      root.addEventListener('click', function (event) {
        var trigger = event.target.closest('.editorial-objections__trigger');
        if (!trigger || !root.contains(trigger)) return;

        var isOpen = trigger.getAttribute('aria-expanded') === 'true';

        root.querySelectorAll('.editorial-objections__trigger').forEach(function (other) {
          if (other !== trigger) other.setAttribute('aria-expanded', 'false');
        });

        trigger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      });
    }

    document.querySelectorAll('[data-editorial-objections]').forEach(init);

    document.addEventListener('shopify:section:load', function (event) {
      var root = event.target.querySelector('[data-editorial-objections]');
      if (root) init(root);
    });
  })();

  (function () {
    var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function revealAll(elements) {
      elements.forEach(function (el) {
        el.classList.add('is-revealed');
      });
    }

    function observe(elements) {
      if (!elements.length) return;

      if (prefersReducedMotion || !('IntersectionObserver' in window)) {
        revealAll(elements);
        return;
      }

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-revealed');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -10% 0px' });

      elements.forEach(function (el) {
        observer.observe(el);
      });
    }

    function init(scope) {
      observe(Array.prototype.slice.call(scope.querySelectorAll('[data-scroll-reveal]:not(.is-revealed)')));
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init(document);
      });
    } else {
      init(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["editorial-outcomes"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function revealAll(elements) {
      elements.forEach(function (el) {
        el.classList.add('is-revealed');
      });
    }

    function observe(elements) {
      if (!elements.length) return;

      if (prefersReducedMotion || !('IntersectionObserver' in window)) {
        revealAll(elements);
        return;
      }

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-revealed');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -10% 0px' });

      elements.forEach(function (el) {
        observer.observe(el);
      });
    }

    function init(scope) {
      observe(Array.prototype.slice.call(scope.querySelectorAll('[data-scroll-reveal]:not(.is-revealed)')));
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init(document);
      });
    } else {
      init(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["editorial-proof"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function revealAll(elements) {
      elements.forEach(function (el) {
        el.classList.add('is-revealed');
      });
    }

    function observe(elements) {
      if (!elements.length) return;

      if (prefersReducedMotion || !('IntersectionObserver' in window)) {
        revealAll(elements);
        return;
      }

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-revealed');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -10% 0px' });

      elements.forEach(function (el) {
        observer.observe(el);
      });
    }

    function init(scope) {
      observe(Array.prototype.slice.call(scope.querySelectorAll('[data-scroll-reveal]:not(.is-revealed)')));
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init(document);
      });
    } else {
      init(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["editorial-recognition"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function revealAll(elements) {
      elements.forEach(function (el) {
        el.classList.add('is-revealed');
      });
    }

    function observe(elements) {
      if (!elements.length) return;

      if (prefersReducedMotion || !('IntersectionObserver' in window)) {
        revealAll(elements);
        return;
      }

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-revealed');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -10% 0px' });

      elements.forEach(function (el) {
        observer.observe(el);
      });
    }

    function init(scope) {
      observe(Array.prototype.slice.call(scope.querySelectorAll('[data-scroll-reveal]:not(.is-revealed)')));
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init(document);
      });
    } else {
      init(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["editorial-reveal"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function revealAll(elements) {
      elements.forEach(function (el) {
        el.classList.add('is-revealed');
      });
    }

    function observe(elements) {
      if (!elements.length) return;

      if (prefersReducedMotion || !('IntersectionObserver' in window)) {
        revealAll(elements);
        return;
      }

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-revealed');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -10% 0px' });

      elements.forEach(function (el) {
        observer.observe(el);
      });
    }

    function init(scope) {
      observe(Array.prototype.slice.call(scope.querySelectorAll('[data-scroll-reveal]:not(.is-revealed)')));
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init(document);
      });
    } else {
      init(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sales-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function centerThumb(thumb, container) {
      if (!thumb || !container) return;
      var containerRect = container.getBoundingClientRect();
      var thumbRect = thumb.getBoundingClientRect();
      var offset = (thumbRect.left + thumbRect.width / 2) - (containerRect.left + containerRect.width / 2);
      var maxScroll = container.scrollWidth - container.clientWidth;
      var target = Math.max(0, Math.min(container.scrollLeft + offset, maxScroll));

      if (container.scrollTo) {
        container.scrollTo({ left: target, behavior: reduceMotion ? 'auto' : 'smooth' });
      } else {
        container.scrollLeft = target;
      }
    }

    function initGallery(gallery) {
      if (gallery.dataset.bound === 'true') return;
      gallery.dataset.bound = 'true';

      var slides = Array.prototype.slice.call(gallery.querySelectorAll('[data-slide]'));
      var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-thumb]'));
      var thumbsContainer = gallery.querySelector('[data-gallery-thumbs]');
      var prevBtn = gallery.querySelector('[data-gallery-prev]');
      var nextBtn = gallery.querySelector('[data-gallery-next]');
      var autoplayToggle = gallery.querySelector('[data-gallery-autoplay-toggle]');
      var activeIndex = 0;

      // Scoping the scroll fix: clicking a thumbnail or arrow used to call
      // Element.scrollIntoView() on the active thumbnail, which in some
      // browsers scrolls ancestor containers (including the whole page)
      // when the thumbnail sits at the start/end of the row. Scrolling the
      // thumbnail strip's own scrollLeft directly avoids touching the page.
      function setActive(index) {
        if (!slides.length) return;
        if (index < 0) index = slides.length - 1;
        if (index >= slides.length) index = 0;
        activeIndex = index;

        slides.forEach(function (slide) {
          slide.classList.toggle('is-active', Number(slide.dataset.index) === activeIndex);
        });
        thumbs.forEach(function (thumb) {
          thumb.classList.toggle('is-active', Number(thumb.dataset.index) === activeIndex);
        });

        centerThumb(thumbs[activeIndex], thumbsContainer);
      }

      var autoplayEnabled = gallery.dataset.autoplay === 'true' && !reduceMotion && slides.length > 1;
      var autoplaySpeed = (Number(gallery.dataset.autoplaySpeed) || 5) * 1000;
      var autoplayTimer = null;
      var userPaused = false;

      function stopAutoplay() {
        if (autoplayTimer) {
          clearInterval(autoplayTimer);
          autoplayTimer = null;
        }
      }

      function startAutoplay() {
        if (!autoplayEnabled || userPaused) return;
        stopAutoplay();
        autoplayTimer = setInterval(function () {
          setActive(activeIndex + 1);
        }, autoplaySpeed);
      }

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          setActive(Number(thumb.dataset.index));
          startAutoplay();
        });
      });

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          setActive(activeIndex - 1);
          startAutoplay();
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          setActive(activeIndex + 1);
          startAutoplay();
        });
      }

      // Swipe support so the gallery is still fully navigable with the
      // arrow buttons hidden on mobile. Listeners stay passive and bail
      // out on mostly-vertical touches so normal page scrolling is
      // never blocked.
      var mainEl = gallery.querySelector('.sales-hero__main');
      if (mainEl && slides.length > 1) {
        var touchStartX = null;
        var touchStartY = null;

        mainEl.addEventListener(
          'touchstart',
          function (event) {
            if (event.touches.length !== 1) return;
            touchStartX = event.touches[0].clientX;
            touchStartY = event.touches[0].clientY;
          },
          { passive: true }
        );

        mainEl.addEventListener(
          'touchend',
          function (event) {
            if (touchStartX === null) return;
            var touch = event.changedTouches[0];
            var deltaX = touch.clientX - touchStartX;
            var deltaY = touch.clientY - touchStartY;
            touchStartX = null;
            touchStartY = null;

            if (Math.abs(deltaX) < 40 || Math.abs(deltaX) < Math.abs(deltaY)) return;

            if (deltaX < 0) {
              setActive(activeIndex + 1);
            } else {
              setActive(activeIndex - 1);
            }
            startAutoplay();
          },
          { passive: true }
        );
      }

      if (autoplayEnabled) {
        startAutoplay();

        gallery.addEventListener('mouseenter', stopAutoplay);
        gallery.addEventListener('mouseleave', function () {
          if (!userPaused) startAutoplay();
        });
        gallery.addEventListener('touchstart', stopAutoplay, { passive: true });

        if (autoplayToggle) {
          autoplayToggle.addEventListener('click', function () {
            userPaused = !userPaused;
            autoplayToggle.setAttribute('aria-pressed', String(userPaused));
            autoplayToggle.classList.toggle('is-paused', userPaused);
            autoplayToggle.setAttribute(
              'aria-label',
              userPaused ? 'Play automatic image rotation' : 'Pause automatic image rotation'
            );
            if (userPaused) {
              stopAutoplay();
            } else {
              startAutoplay();
            }
          });
        }

        if ('IntersectionObserver' in window) {
          new IntersectionObserver(
            function (entries) {
              entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                  if (!userPaused) startAutoplay();
                } else {
                  stopAutoplay();
                }
              });
            },
            { threshold: 0.3 }
          ).observe(gallery);
        }
      }
    }

    function initQuantity(wrapper) {
      if (wrapper.dataset.bound === 'true') return;
      wrapper.dataset.bound = 'true';

      var input = wrapper.querySelector('[data-qty-input]');
      var decreaseBtn = wrapper.querySelector('[data-qty-decrease]');
      var increaseBtn = wrapper.querySelector('[data-qty-increase]');
      if (!input) return;

      function clamp(value) {
        var min = Number(input.min) || 1;
        var max = Number(input.max) || 99;
        if (isNaN(value)) value = min;
        return Math.min(max, Math.max(min, value));
      }

      if (decreaseBtn) {
        decreaseBtn.addEventListener('click', function () {
          input.value = clamp(Number(input.value) - 1);
        });
      }
      if (increaseBtn) {
        increaseBtn.addEventListener('click', function () {
          input.value = clamp(Number(input.value) + 1);
        });
      }
      input.addEventListener('change', function () {
        input.value = clamp(Number(input.value));
      });
    }

    function init(scope) {
      scope.querySelectorAll('[data-gallery]').forEach(initGallery);
      scope.querySelectorAll('[data-quantity]').forEach(initQuantity);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(document); });
    } else {
      init(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
